import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center right" }
const _hoisted_2 = {
  class: "d-flex btn btn-icon align-items-center nav-link",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  "data-bs-offset": "[0,10]"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-diagram-3-fill" }, null, -1)
const _hoisted_4 = { class: "ms-2" }
const _hoisted_5 = { class: "dropdown-header font-semibold" }
const _hoisted_6 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_7 = { class: "me-5 col-8" }
const _hoisted_8 = { class: "ms-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear-fill" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card-2-back-fill" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "dropdown-divider my-3"
}
const _hoisted_13 = {
  key: 1,
  class: "dropdown-header font-semibold"
}
const _hoisted_14 = { class: "list-organizations overflow-y-auto" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "ms-auto" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear-fill" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card-2-back-fill" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider my-3" }, null, -1)
const _hoisted_21 = { class: "px-3" }
const _hoisted_22 = { class: "ms-4" }
const _hoisted_23 = {
  class: "d-flex btn btn-icon nav-link align-items-center",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  "data-bs-offset": "[0,10]"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill" }, null, -1)
const _hoisted_25 = { class: "ms-2" }
const _hoisted_26 = { class: "dropdown-header font-semibold d-none" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "ni ni-single-02" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-power" }, null, -1)
const _hoisted_30 = { class: "ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoComponent = _resolveComponent("LogoComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DropdownComponent = _resolveComponent("DropdownComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LogoComponent, {
      viewBox: "0 0 185 32",
      width: "93",
      aClass: "d-flex align-items-center"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("a", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$store.state.organization.name), 1)
        ]),
        _createVNode(_component_DropdownComponent, null, {
          content: _withCtx(() => [
            _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
								_ctx.$text('expressions', 'Switch_Organization_Current_Title')
							)), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$store.state.organization.name), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.$permission.canGetOrganization())
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
									name: _ctx.$config('RouteConfig', 'OrganizationUpdateRouteName'),
									params: { organization_id: _ctx.$store.state.organization._id },
								},
                      class: "a-icon p-1"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (
									_ctx.$permission.canListOrganizationUsers(
										_ctx.$store.state.organization.role
									)
								)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: {
									name: _ctx.$config('RouteConfig', 'OrganizationRolesRouteName'),
									params: {
										organization_id: _ctx.$store.state.organization._id,
										space_id: _ctx.$store.state.space._id,
									},
								},
                      class: "a-icon p-1"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (
									_ctx.$permission.canUpdateOrganizationBilling(
										_ctx.$store.state.organization.role
									)
								)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: {
									name: _ctx.$config('RouteConfig', 'SpaceBillingRouteName'),
									params: {
										organization_id: _ctx.$store.state.organization._id,
										space_id: _ctx.$store.state.space._id,
									},
								},
                      class: "a-icon p-1"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.$store.state.organizations.length > 1)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.$store.state.organizations.length > 1)
              ? (_openBlock(), _createElementBlock("h6", _hoisted_13, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
								_ctx.$text('expressions', 'Switch_Organization_Change_Title')
							)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.organizations.filter(
								(organization) =>
									organization._id !== _ctx.$store.state.organization._id
							), (organization, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "dropdown-item d-flex align-items-center",
                  key: index
                }, [
                  _createElementVNode("a", {
                    class: "col-8",
                    onClick: ($event: any) => (_ctx.switchOrganization(organization))
                  }, _toDisplayString(organization.name), 9, _hoisted_15),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.$permission.canGetOrganization(organization.role))
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
										name: 'organization-update',
										params: { organization_id: organization._id },
									},
                          class: "a-icon p-1"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.$permission.canListOrganizationUsers(organization.role))
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: {
										name: _ctx.$config('RouteConfig', 'OrganizationRolesRouteName'),
										params: { organization_id: organization._id },
									},
                          class: "a-icon p-1"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (
										_ctx.$permission.canUpdateOrganizationBilling(organization.role)
									)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 2,
                          to: {
										name: _ctx.$config(
											'RouteConfig',
											'OrganizationBillingRouteName'
										),
										params: { organization_id: organization._id },
									},
                          class: "a-icon p-1"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "btn btn-sm text-white btn-brand w-full",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
								_ctx.$limitation.organizationsLimitReached()
									? _ctx.showPaymentModal()
									: _ctx.$router.push({
											name: _ctx.$config(
												'RouteConfig',
												'OrganizationCreateRouteName'
											),
									  })
							)),
                type: "button"
              }, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
									_ctx.$text('actions', 'Create_An_Organization')
								)), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("a", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$store.state.profile.firstname)) + " " + _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$store.state.profile.lastname)), 1)
        ]),
        _createVNode(_component_DropdownComponent, null, {
          content: _withCtx(() => [
            _createElementVNode("h6", _hoisted_26, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$store.state.profile.firstname)) + " " + _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$store.state.profile.lastname)), 1),
            _createVNode(_component_router_link, {
              to: { name: _ctx.$config('RouteConfig', 'ProfileUpdateRouteName') },
              class: "dropdown-item"
            }, {
              default: _withCtx(() => [
                _hoisted_27,
                _createElementVNode("span", null, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('words', 'Profile'))), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_28,
            _createElementVNode("a", {
              class: "dropdown-item d-flex align-items-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
            }, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Logout'))), 1)
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}